/* eslint-disable */
require('./404')
require('./bug')
require('./chart')
require('./clipboard')
require('./component')
require('./dashboard')
require('./documentation')
require('./drag')
require('./edit')
require('./email')
require('./example')
require('./excel')
require('./eye')
require('./form')
require('./guide')
require('./icon')
require('./international')
require('./language')
require('./list')
require('./lock')
require('./message')
require('./money')
require('./password')
require('./people')
require('./peoples')
require('./qq')
require('./shoppingCard')
require('./star')
require('./tab')
require('./table')
require('./theme')
require('./user')
require('./wechat')
require('./zip')



// WEBPACK FOOTER //
// ./src/icons/index.js